__turbopack_context__.v({
  "searchButton": "search-button-module__80Vd7a__searchButton",
});
